import { IS_LOADING, SET_ERROR, SET_SUCCESS, SET_DATA_ITEM, SET_DATA_LIST, SET_TOTAL, SET_DATA_ID } from "@/store/Crud/functions/mutations";
import { SET_DATA_EXAM, SET_DATA_LIST_BY_COURSE } from "./types";
export default {
    IS_LOADING,
    SET_ERROR,
    SET_SUCCESS,
    SET_DATA_ITEM,
    SET_DATA_LIST,
    SET_TOTAL,
    SET_DATA_ID,
    [SET_DATA_EXAM](state, exams) {
        Object.assign(state, { exams });
    },
    [SET_DATA_LIST_BY_COURSE](state, studentsByCourse) {
        Object.assign(state, { studentsByCourse });
    },
};
